import script from "./DetailsView.vue?vue&type=script&setup=true&lang=js"
export * from "./DetailsView.vue?vue&type=script&setup=true&lang=js"

import "./DetailsView.vue?vue&type=style&index=0&id=57c3925c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57c3925c"]])

export default __exports__